import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ScheduledSectionStatus } from '../../views/course_scheduler/types/scheduled_section_status_enum';
import { SectionSwapModel } from '../models/course_section_swap_model';

export type ClearSwapToSectionsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'clearSwapToSectionsCommand',
    function clearSwapToSectionsCommandDefinition(
      defineCommandORM: IDefineCommand,
      updateSwapSectionStatusCommand: ICommand,
      ngCourseSectionSwapModel: SectionSwapModel
    ) {
      return defineCommandORM('clearSwapToSectionsCommand', function clearSwapToSectionsCommand(deferred) {
        const currentSwap = ngCourseSectionSwapModel.read();
        const swapToSections = currentSwap.swap_to_section_ids.map((section) => section.id);
        updateSwapSectionStatusCommand(swapToSections, ScheduledSectionStatus.UNSCHEDULED).then(() => {
          ngCourseSectionSwapModel.clear().write({
            ...currentSwap,
            swap_to_section_ids: []
          });
          deferred.resolve();
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/clear_swap_to_sections_command.ts